import { createFeedbackRateLimiter } from "@heraion/shared";

import { webStorage } from "./webStorage";

// Web half of the feedback client-side ceiling: same window and 10/hour as
// mobile (shared in @heraion/shared), timestamps kept in localStorage via the
// guarded webStorage (memory fallback when the browser refuses access).
export const checkAndRecord = createFeedbackRateLimiter(
  webStorage,
  "jl.feedback.recent.v1",
);
